import { Component } from '@angular/core';

@Component({
    selector: 'close-icon-component',
    template: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_392_13819)">
          <path
            d="M14.192 4.34424L9.94897 8.58624L5.70697 4.34424L4.29297 5.75824L8.53497 10.0002L4.29297 14.2422L5.70697 15.6562L9.94897 11.4142L14.192 15.6562L15.606 14.2422L11.364 10.0002L15.606 5.75824L14.192 4.34424Z"
            fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_392_13819">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    `,
    styles: []
})
export class CloseIconComponent {}